import { render, staticRenderFns } from "./profile-tab-navigation.vue?vue&type=template&id=7837f716&scoped=true"
import script from "./profile-tab-navigation.vue?vue&type=script&lang=js"
export * from "./profile-tab-navigation.vue?vue&type=script&lang=js"
import style0 from "./profile-tab-navigation.vue?vue&type=style&index=0&id=7837f716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837f716",
  null
  
)

export default component.exports